import Profile from 'views/Profile/Profile.jsx';

// @material-ui/icons
import PersonIcon from '@material-ui/icons/Person';
import Work from '@material-ui/icons/Work';
import Contacts from '@material-ui/icons/Contacts';
import CalendarToday from '@material-ui/icons/CalendarToday';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import Chat from '@material-ui/icons/Chat';
import LocalOffer from '@material-ui/icons/LocalOffer';
import SettingsApplications from '@material-ui/icons/SettingsApplications';

import Cases from '../views/Cases/Cases.jsx';
import CaseDetails from '../views/Cases/CaseDetails.jsx';
import Explore from '../views/Explore/Explore.jsx';
import LawyerDetails from '../views/Explore/LawyerDetails.jsx';
import Calendar from '../views/Calendar/CalendarTest.jsx';
import Notifications from '../views/Notifications/Notifications.jsx';
import ChatPage from '../views/Chat/Chat.jsx';
import Offers from '../views/Offers/Offers.jsx';
import Settings from '../views/Settings/Settings.jsx';
import Threads from '../views/Chat/Threads/Threads.jsx';
import ChatCasesDetails from '../views/Chat/ChatCasesDetails.jsx';
import ClientThreads from '../views/Chat/ClientThreads.jsx';
import EventsDetails from '../views/Calendar/EventsDetails.jsx';
import ThreadPermissions from '../views/Chat/Permissions/ThreadPermissions.jsx';
import CasePermissions from '../views/Cases/Permissions/CasePermissions.jsx';
import Setup from '../views/Setup/Setup.jsx';
import Legal from '../views/Setup/Legal.jsx';
import LegalDisclaimer from '../views/Setup/LegalDisclaimer.jsx';
import CreateCaseForm from '../components/Forms/CreateCaseForm.jsx';
import CreateFirmForm from '../components/Forms/CreateFirmForm.jsx';
import PrivacyPolicy from '../views/Setup/PrivacyPolicy.jsx';
import PendingCasesDetails from '../views/Cases/PendingCasesDetails.jsx';

export default [
  { path: '/profile', name: 'Profile', icon: PersonIcon, component: Profile },
  {
    path: '/cases/:type',
    admin: true,
    name: 'Cases',
    icon: Work,
    component: Cases,
  },
  {
    path: '/case/:type/:id',
    admin: true,
    name: 'Cases',
    icon: Work,
    component: CaseDetails,
  },

  { path: '/cases', name: 'Cases', icon: Work, component: Cases },
  { path: '/explore', name: 'Explore', icon: Contacts, component: Explore },
  { path: '/chat', name: 'Chat', icon: Chat, component: ChatPage },
  { path: '/calendar', name: 'Calendar', icon: CalendarToday, component: Calendar },
  // { path: "/retainers", name: "Retainers", icon: Assessment, component: Analytics },
  { path: '/offers', name: 'Offers', icon: LocalOffer, component: Offers },
  {
    path: '/notifications',
    name: 'Notifications',
    icon: NotificationImportant,
    component: Notifications,
  },
  {
    path: '/settings',
    name: 'Settings',
    icon: SettingsApplications,
    component: Settings,
  },
  { path: '/threads/:id', admin: true, name: 'threads', component: Threads },
  {
    path: '/:caseid/clientthreads/:threadid',
    admin: true,
    name: 'threads',
    component: ClientThreads,
  },
  { path: '/case/:id', admin: true, name: 'threads', component: CaseDetails },
  {
    path: '/pending-case/:id',
    admin: true,
    name: 'threads',
    component: PendingCasesDetails,
  },
  { path: '/event/:id', admin: true, name: 'threads', component: EventsDetails },
  {
    path: '/casechat/:id',
    admin: true,
    name: 'threads',
    component: ChatCasesDetails,
  },
  {
    path: '/threadshare/:id/:role',
    admin: true,
    name: 'permissions',
    component: ThreadPermissions,
  },
  {
    path: '/caseshare/:id/:role',
    admin: true,
    name: 'permissions',
    component: CasePermissions,
  },
  {
    path: '/lawyer/:id',
    admin: true,
    name: 'permissions',
    component: LawyerDetails,
  },
  { path: '/setup', admin: true, name: 'Setup', component: Setup },
  { path: '/setup/:caseid', admin: true, name: 'Setup', component: Setup },
  { path: '/legal', admin: true, name: 'Legal', component: Legal },
  {
    path: '/legal-disclaimer',
    admin: true,
    name: 'Legal Disclaimer',
    component: LegalDisclaimer,
  },
  {
    path: '/create-case',
    admin: true,
    name: 'Create Case',
    component: CreateCaseForm,
  },
  {
    path: '/create-firm',
    admin: true,
    name: 'Create Firm',
    component: CreateFirmForm,
  },
  {
    path: '/privacy-policy',
    admin: true,
    name: 'Privacy Policy',
    component: PrivacyPolicy,
  },
  {
    path: '/',
    admin: true,
    name: 'Privacy Policy',
    component: Cases,
  },
  // { path: "/archived", admin: true, name: "Archived Cases", component: Archived },

  // {
  //   collapse: true,
  //   path: "/learn",
  //   name: "Learn",
  //   icon: DashboardIcon,
  //   state: "openLearn",
  //   views: [
  //     { path: "/learn/core-beliefs", name: "Core Beliefs", component: Profile },
  //     { path: "/learn/principles", name: "Principles", component: Profile },
  //     { path: "/learn/practices", name: "Practices", component: Profile }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/assess",
  //   name: "Assess",
  //   icon: DashboardIcon,
  //   state: "openAssess",
  //   views: [
  //     { path: "/assess/assessment", name: "Take the Assessment", component: TakeAssessment },
  //     { path: "/assess/path", name: "Path to Purposeful Leadership", component: Profile },
  //     { path: "/assess/purpose", name: "Purpose Embraced Path", component: Profile },
  //     { path: "/assess/stakeholders", name: "Stakeholders Engaged Path", component: Profile },
  //     { path: "/assess/strategy", name: "Strategy Aligned Path", component: Profile },
  //     { path: "/assess/actions", name: "Actions Aligned Path", component: Profile }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/grow",
  //   name: "Grow",
  //   icon: DashboardIcon,
  //   state: "openGrow",
  //   views: [
  //     { path: "/grow/articles", name: "Articles Library", component: Profile },
  //     { path: "/grow/tudies", name: "Research Studies Library", component: Profile },
  //     { path: "/grow/books", name: "Books Library", component: Profile },
  //     { path: "/grow/share", name: "Share a Resource", component: Profile },
  //     { path: "/grow/consultants", name: "Directory of Consultants", component: Profile },
  //     { path: "/grow/professionals", name: "Directory of Consultants", component: Profile },
  //     { path: "/grow/courses", name: "Upcoming Courses", component: Profile },
  //     { path: "/grow/archive", name: "Course Archive", component: Profile },
  //     { path: "/grow/suggest", name: "Suggest a Course or Webinar", component: Profile }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/connect",
  //   name: "Connect",
  //   icon: DashboardIcon,
  //   state: "openConnect",
  //   views: [
  //     { path: "/connect/communities", name: "Communities of Interest", component: Profile },
  //     { path: "/connect/blog", name: "Blog", component: Profile },
  //     { path: "/connect/newsletter", name: "Newsletter", component: Profile },
  //     { path: "/connect/radio", name: "Radio", component: Profile },
  //     { path: "/connect/group-calls", name: "Group Calls", component: Profile },
  //     { path: "/connect/group-calls", name: "Affliates", component: Profile },
  //     { path: "/connect/member", name: "Become a Member", component: Profile },
  //     { path: "/connect/partner", name: "Become a Partner", component: Profile },
  //     { path: "/connect/champion", name: "Become a Champion", component: Profile },
  //     { path: "/connect/sponsor", name: "Become a Sponsor or Donor", component: Profile },
  //     { path: "/connect/advocate", name: "Become an Advocate", component: Profile },
  //     { path: "/connect/marketplace", name: "Talent Marketplace", component: Profile }

  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/about",
  //   name: "About",
  //   icon: DashboardIcon,
  //   state: "openAbout",
  //   views: [
  //     { path: "/about/who-we-are", name: "Who we Are", component: Profile },
  //     { path: "/about/champions", name: "Our Champions", component: Profile },
  //     { path: "/about/bbard", name: "Our Board Members", component: Profile },
  //     { path: "/about/sponsors", name: "Our Sponsors", component: Profile },
  //     { path: "/about/memmbers", name: "Member Directory", component: Users }
  //   ]
  // },
  // { path: "/contact", name: "Contact", component: Profile },

  // { path: "/dashboard/apply", name: "Job Application", component: JobApplication },
  // {
  //   collapse: true,
  //   path: "/admin",
  //   name: "Admin",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/field",
  //   name: "Field",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/communications",
  //   name: "Communications",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/volunteers",
  //   name: "Volunteers",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/political",
  //   name: "Political",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/fundraising",
  //   name: "Fundraising",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/treasurer",
  //   name: "Treasurer",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/legal",
  //   name: "Legal",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/technology",
  //   name: "Technology",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/scheduling",
  //   name: "Scheduling",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // }
];
